import { FC } from 'react'

import { Textarea as MantineTextarea, TextareaProps } from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants.ts'

const StyledInput = styled(MantineTextarea)`
  position: relative;
  width: 100%;

  input {
    height: 41px;
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};

    &::placeholder {
      opacity: 0.5;
      font-size: 12px;
    }
  }

  label {
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 1;
    width: fit-content;
    background-color: white;
    padding: 0 5px;
    font-size: 12px;
    color: ${colors.thirdGray};
  }
`

export type InputProps = TextareaProps & {
  error?: string
}
export const Textarea: FC<InputProps> = (props) => {
  return <StyledInput {...props} />
}
